/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

export const UNUSED_PRODUCT_KEYS = {
	fullImageRaw: true,
	thumbnailRaw: true,
	storeID: true,
	parent: true,
};

export const UNUSED_PRICE_KEYS = {
	description: true,
};
